const ErrorComponent = ({ text }) => {
  return <span className='text-[12px] md:text-[14px] text-red'>{text}</span>;
};

export default ErrorComponent;
